// Log opcode handlers (0xa0-0xa4)

export { handler_0xa0_LOG0 } from "./0xa0_LOG0.js";
export { handler_0xa1_LOG1 } from "./0xa1_LOG1.js";
export { handler_0xa2_LOG2 } from "./0xa2_LOG2.js";
export { handler_0xa3_LOG3 } from "./0xa3_LOG3.js";
export { handler_0xa4_LOG4 } from "./0xa4_LOG4.js";
